// extracted by mini-css-extract-plugin
export default {"image":"Image_image__HEBYj","imgCard":"Image_imgCard__nf08k","actions":"Image_actions__HXGRg","gallery":"Image_gallery__-zREh","name":"Image_name__A9XvS"};